import React from 'react';
import ItemCard from '../ItemCard';
import Icon from '../Icon';
import './style.less';

interface CreateCard {
  height?: string,
  width?: string,
  content?: string,
  marginTop?: string,
  contentStyle?: React.CSSProperties,
  handleClick?: () => void,
}
const clsPrefix = 'c-create-card';
const CreateCard:React.FC<CreateCard> = ({
  height = '402px',
  width = '230px',
  marginTop = '126px',
  content = '绑定新公众号',
  contentStyle = {},
  handleClick = () => (null),
}) => {
  return(
    <ItemCard style={{ height: height, width: width }}>
      <div className={clsPrefix} onClick={handleClick} style={{ marginTop }}>
        <Icon name="new" style={{ fontSize: '36px', color: '#477EF7', cursor:'pointer'}} />
        <div className={`${clsPrefix}__text`} style={contentStyle}>{content}</div>
      </div>
    </ItemCard>
  )
}

export default CreateCard;